<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'WechatPayOrder',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '待支付',
        }, {
          key: 3,
          value: '支付成功',
        }, {
          key: 0,
          value: '支付失败',
        }]
      },{
        name: 'type',
        placeholder: '支付类型',
        type: 'select',
        selectValue: [{
          key: 1,
          value: 'H5支付',
        }, {
          key: 2,
          value: '小程序支付',
        }]
      }, {
        name: 'outOrderNo',
        placeholder: '外部订单号',
        type: 'input'
      }, {
        name: 'inOrderNo',
        placeholder: '系统订单号',
        type: 'input'
      }, {
        name: 'startTime',
        placeholder: '回调开始时间',
        type: 'dateTime'
      },
        {
          name: 'endTime',
          placeholder: '回调结束时间',
          type: 'dateTime'
        }],
      permission: {
        add: 'wechatPayOrder:add',
        update: 'wechatPayOrder:update',
        delete: 'wechatPayOrder:delete',
        deleteBatch: 'wechatPayOrder:deleteBatch'
      },
      url: {
        get: '/wechatPayOrder/listByCondition',
        add: '/wechatPayOrder/add',
        update: '/wechatPayOrder/update',
        delete: '/wechatPayOrder/delete',
        delete_batch: '/wechatPayOrder/deleteBatch',
        status: '/wechatPayOrder/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        detail: true,
      }, {
        field: 'merchantUid',  // 字段名
        label: '商户号',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'appId',  // 字段名
        label: 'appId',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'amount',  // 字段名
        label: '金额',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'title',  // 字段名
        label: '标题',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'validTime',  // 字段名
        label: '订单过期时间',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'inOrderNo',  // 字段名
        label: '系统订单号',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'outOrderNo',  // 字段名
        label: '外部订单号',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'status',
        label: '支付状态',
        show: {
          type: 'select'
        },
        selectUrl: '',
        selectData: [
          {
            id: 1,
            name: '待支付'
          },
          {
            id: 2,
            name: '待查询'
          },
          {
            id: 3,
            name: '成功'
          },
          {
            id: 0,
            name: '失败'
          },
          {
            id: 4,
            name: '支付超时'
          },
          {
            id: 5,
            name: '支付取消'
          }
        ],
        width: '',
      },{
        field: 'type',
        label: '支付类型',
        show: {
          type: 'select'
        },
        selectUrl: '',
        selectData: [
          {
            id: 1,
            name: 'H5支付'
          },
          {
            id: 2,
            name: '小程序支付'
          }
        ],
        width: '',
      }, {
        field: 'eventTime',  // 字段名
        label: '用户操作时间',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'channelPayId',  // 字段名
        label: '渠道支付单号',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'openId',  // 字段名
        label: 'openId',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      },{
        field: 'rechargeType',
        label: '充值类型',
        show: {
          type: 'select'
        },
        selectUrl: '',
        selectData: [
          {
            id: 1,
            name: '余额充值'
          },
          {
            id: 2,
            name: '购买套餐'
          }
        ],
        width: '',
      }, {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              {required: true, message: 'agentId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'userId',  // 字段名
            label: 'userId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userId',
            rules: [
              {required: true, message: 'userId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'appId',  // 字段名
            label: 'appId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入appId',
            rules: [
              {required: true, message: 'appId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'amount',  // 字段名
            label: 'amount',  // 字段显示名称
            type: 'input',
            placeholder: '请输入amount',
            rules: [
              {required: true, message: 'amount不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'title',  // 字段名
            label: 'title',  // 字段显示名称
            type: 'input',
            placeholder: '请输入title',
            rules: [
              {required: true, message: 'title不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'validTime',  // 字段名
            label: 'validTime',  // 字段显示名称
            type: 'input',
            placeholder: '请输入validTime',
            rules: [
              {required: true, message: 'validTime不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'inOrderNo',  // 字段名
            label: 'inOrderNo',  // 字段显示名称
            type: 'input',
            placeholder: '请输入inOrderNo',
            rules: [
              {required: true, message: 'inOrderNo不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'outOrderNo',  // 字段名
            label: 'outOrderNo',  // 字段显示名称
            type: 'input',
            placeholder: '请输入outOrderNo',
            rules: [
              {required: true, message: 'outOrderNo不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: 'status',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              {required: true, message: 'status不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'eventTime',  // 字段名
            label: 'eventTime',  // 字段显示名称
            type: 'input',
            placeholder: '请输入eventTime',
            rules: [
              {required: true, message: 'eventTime不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'merchantUid',  // 字段名
            label: 'merchantUid',  // 字段显示名称
            type: 'input',
            placeholder: '请输入merchantUid',
            rules: [
              {required: true, message: 'merchantUid不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'channelPayId',  // 字段名
            label: 'channelPayId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入channelPayId',
            rules: [
              {required: true, message: 'channelPayId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'channelNo',  // 字段名
            label: 'channelNo',  // 字段显示名称
            type: 'input',
            placeholder: '请输入channelNo',
            rules: [
              {required: true, message: 'channelNo不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
